import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useRouteParam } from '@hooks/params';

import { billingFetch, BillingFetchPayload, insurancePolicyFetch, InsurancePolicyFetchPayload } from './action';
import { selectInsurancePolicyBuyRoute } from './selector';

export const useInsurancePolicyFetch = () => {
  const dispatch = useDispatch();
  const insurancePolicyId = Number(useRouteParam('insurancePolicyId'));
  const { policy } = useSelector(selectInsurancePolicyBuyRoute);

  useEffectOnce(() => {
    const payload: InsurancePolicyFetchPayload = { id: insurancePolicyId };
    dispatch(insurancePolicyFetch(payload));
  });

  return policy;
};

export const useBillingFetch = () => {
  const dispatch = useDispatch();
  const insurancePolicyId = Number(useRouteParam('insurancePolicyId'));
  const { billing } = useSelector(selectInsurancePolicyBuyRoute);

  useEffectOnce(() => {
    const payload: BillingFetchPayload = { id: insurancePolicyId };
    dispatch(billingFetch(payload));
  });

  return billing;
}
